import { ROOT_URL } from 'envs/_current/config'
import { channelSchema } from '../schema'
import base, {
  get,
  getLinkToDetailGenerator,
  getLinkToSettingGenerator,
  getLinkToShareGenerator,
  getType
} from './base'
const getId = get('idname')
export const getLinkToDetail = getLinkToDetailGenerator(
  { getId, getType }
)
export const getLinkToSetting = getLinkToSettingGenerator(
  { getId, getType }
)
export const getLinkToShare = getLinkToShareGenerator(
  { rootUrl: ROOT_URL, getType, getId }
)
export default {
  ...base,
  getLinkToDetail,
  getLinkToSetting,
  getLinkToShare,
  schema: channelSchema,
  getId
}
